import { useIntl } from "react-intl";

import { defaultHeroProps } from "./all-teams";
import { PaidHeroTabPanelTemplate } from "./hero-tab-panel-template";

const DesignTabContent = () => {
    const intl = useIntl();

    const designHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.hero.design.header",
            defaultMessage: "Unleash innovative design work with Jira"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/stwkq56nns422b0684fodlf0074s3b6e.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.design.heroImageAlt",
                defaultMessage: "Screen capture of a Jira design ticket"
            })
        }
    };

    return (
        <PaidHeroTabPanelTemplate {...designHeroProps} {...defaultHeroProps} />
    );
};

export default DesignTabContent;
